import { ProductAnalysisEntity } from '@/entities/product-analysis.entity';
import { useCallback } from 'react';
import { useMarketplaceApi } from '@/context/marketplace.context';
import { useSingleGroupTableAnalysis } from '@/components/group-tables/use-group-table-analysis';

type BrandGroupForAnalysis = {
    name: string;
    productGroupIds: string[];
};

type UseBrandsTableAnalysisArgs = {
    accessToken: string;
};

export const useBrandsTableAnalysis = <TBrandGroup extends BrandGroupForAnalysis>({
    accessToken,
}: UseBrandsTableAnalysisArgs) => {
    const { productsApi } = useMarketplaceApi();

    const loadBrandGroupAnalysis = useCallback(
        async (brandGroup: TBrandGroup, { signal }: { signal: AbortSignal }) => {
            const response = await productsApi.getCombinedProductAnalysis(brandGroup.productGroupIds, {
                authToken: accessToken,
                signal,
            });
            return response.data;
        },
        [accessToken, productsApi],
    );

    const {
        openedTarget: openedBrandGroup,
        openedTargetData: openedBrandGroupAnalysis,
        isLoading: isBrandGroupAnalysisLoading,
        error: brandGroupAnalysisError,
        onClose: onBrandGroupAnalysisClose,
        onOpen: onBrandGroupClick,
    } = useSingleGroupTableAnalysis<TBrandGroup, ProductAnalysisEntity>({
        load: loadBrandGroupAnalysis,
        errorMessage: 'Не удалось загрузить анализ группы брендов.',
    });

    return {
        openedBrandGroup,
        openedBrandGroupAnalysis,
        isBrandGroupAnalysisLoading,
        brandGroupAnalysisError,
        onBrandGroupAnalysisClose,
        onBrandGroupClick,
    };
};
